'use client'

import { AchieveLink } from '@/components/AchieveLink'
import { MediaImageStandard } from 'components/Contentful'
import { Typography } from 'components/Typography'
import classNames from 'classnames'
import { useActiveNav } from '../context/ActiveNavContext'

export const SubnavDefaultSection = ({ data, isMobile, setHoverSubnav }) => {
  const isSimpleList = !(data?.children?.length > 1)
  const columns = data?.columns || 1
  const { isActive } = useActiveNav()

  if (isMobile) {
    return (
      <div
        data-testid="mega-menu-subnav-default-section-mobile"
        className="flex flex-col gap-4 w-screen bg-blue-25 px-10 py-6"
      >
        {data?.children?.map((child, index) => (
          <div
            key={`${data.id}-${child.id}`}
            className={classNames(
              'flex flex-col gap-2 pb-4 border-solid border-gray-300 border-0 border-b',
              { 'last:border-b-0': index === data.children.length - 1 }
            )}
          >
            {!isSimpleList && (
              <Typography content={child.label} className="labelSm text-gray-500 font-bold!" />
            )}
            <div className={classNames('flex flex-col gap-4', { 'gap-2': isSimpleList })}>
              {child?.children?.map((subChild, subChildIndex) => (
                <AchieveLink
                  href={subChild.link}
                  key={`${data.id}-${subChild.id}-${subChild.id}`}
                  aria-current={isActive(subChild) ? 'page' : undefined}
                  className={classNames('text-black', {
                    'pb-2 border-solid border-gray-300 border-0 border-b': isSimpleList,
                    'border-b-0!': subChildIndex === child.children.length - 1,
                  })}
                  track={{
                    click_id: subChild.label,
                    click_text: subChild.label,
                    click_url: subChild.link,
                    nav_link_section: 'Mega Menu',
                    track_event: 'mega_menu',
                    event_action: 'link_click',
                    event_type: 'link_click',
                  }}
                >
                  <div className={classNames('flex flex-row gap-2 items-center')}>
                    <Typography
                      content={subChild.label}
                      className={classNames('labelMd', {
                        'text-blue-900 font-bold!': isActive(subChild),
                      })}
                    />
                  </div>
                </AchieveLink>
              ))}
            </div>
          </div>
        ))}
      </div>
    )
  }

  const groupItems = () => {
    const groups = []
    const items = data.children || []

    for (let i = 0; i < items.length; i += columns) {
      groups.push(items.slice(i, i + columns))
    }

    return groups
  }

  const itemGroups = groupItems()

  return (
    <div data-testid="mega-menu-subnav-default-section" className="flex flex-col gap-2 p-8">
      {itemGroups.map((group, groupIndex) => (
        <div
          key={`group-${groupIndex}`}
          className="grid gap-4"
          style={{
            gridTemplateColumns: `repeat(${columns}, 1fr)`,
          }}
        >
          {group.map((child) => (
            <div key={`${data.id}-${child.id}`} className="flex flex-col gap-2">
              {!isSimpleList && (
                <Typography
                  content={child.label}
                  className="uppercase text-neutral-300 font-bold! tracking-[3.5px]"
                  variant="bodySm"
                />
              )}
              <div className={classNames('flex flex-col gap-4', { 'gap-2': isSimpleList })}>
                {child.children?.map((subChild) => (
                  <AchieveLink
                    href={subChild.link}
                    key={`${data.id}-${subChild.id}-${subChild.id}`}
                    className={'text-black no-underline!'}
                    aria-current={isActive(subChild) ? 'page' : undefined}
                    onClick={() => {
                      setHoverSubnav(false)
                    }}
                    track={{
                      click_id: subChild.label,
                      click_text: subChild.label,
                      click_url: subChild.link,
                      nav_link_section: 'Mega Menu',
                      track_event: 'mega_menu',
                      event_action: 'link_click',
                      event_type: 'link_click',
                    }}
                  >
                    <div
                      className={classNames(
                        'flex flex-row gap-6 items-center hover:bg-blue-25 rounded-md px-1 py-4',
                        { 'bg-blue-50': isActive(subChild) }
                      )}
                    >
                      <div>
                        <MediaImageStandard
                          content={{ url: subChild.icon, fileName: subChild.label }}
                          layout="responsive"
                          width={35}
                          height={35}
                        />
                      </div>
                      <div className={classNames('flex flex-col gap-2')}>
                        <Typography
                          content={subChild.label}
                          className={classNames('labelMd font-bold!', {
                            'text-blue-900': isActive(subChild),
                          })}
                        />
                        <Typography
                          content={subChild.description}
                          className="labelSm !font-regular text-gray-500"
                        />
                      </div>
                    </div>
                  </AchieveLink>
                ))}
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
  )
}

export default SubnavDefaultSection
